<template>
  <div style="width: 100%;">
    <div class="title-h4 title-bar">기본 관리 도구</div>
    <el-table ref="table" :data="tableData" :show-header="false" @row-click="excuteLauncher" :row-style="{cursor: 'pointer'}" fit style="width: 100%;">
      <el-table-column prop="label" />
    </el-table>
  </div>
</template>

<script>
import { isNil, isEmpty, mapKeys, remove } from 'lodash';
import { objType } from '@/constants/obj';
import { applicationLauncher } from '@/utils/applauncher';
import { routePathByObjId } from '@/utils/router';
import appApi from '@/api/common/app';
import V10API from '@/api/common/v10';
import msgUtil from '@/utils/message';
import { menuDefine } from '@/constants/menu';
import { customer } from '@/constants/customer-define';

export default {
  name: 'WBasicSlidingButtonGroup',
  props: {
    objInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      customer,
    };
  },
  updated() {
    // IE에서 맨 처음 랜더링 될 때 너비 계산이 안되어서 컬럼너비가 좁게 보임.
    if (this.$refs.table) {
      this.$refs.table.debouncedUpdateLayout();
    }
  },
  computed: {
    tableData() {
      let tableData = [];
      // 무선 장비인 경우는 두가지 기능만 제공한다.
      if (this.objInfo.subType !== objType.WIRELESS_AP || isNil(this.objInfo.obj.parentObjId)) {
        tableData = [
          { label: '토폴로지맵', exectype: 'TOPOLOGYMAP' },
          { label: 'Ping', exectype: 'PING' },
          { label: '터미널', exectype: 'TERMINAL' },
          { label: 'IP Scan', exectype: 'IP_SCAN' },
          { label: 'MIB Browser', exectype: 'MIB_BROWSER' },
          { label: 'Trace Route', exectype: 'TRACE_ROUTE' },
          { label: 'Web Link', exectype: 'LINK_WWW' },
          // { label: 'FTP', exectype: 'FTP' },
          // { label: 'FTP 파일 관리자', exectype: 'FTP_FILE_MANAGER' },
          { label: 'Net State', exectype: 'NET_STAT' },
          { label: 'Path Ping', exectype: 'PATH_PING' },
        ];
        // tableData.push({ label: 'Mib Browser', exectype: 'MIB_BROWSER' }); // TODO 미구현
        if (this.objInfo.subType === objType.NETDEVICE) {
          tableData.push({ label: 'R-Mon Browser', exectype: 'RMON_BROWSER' });
          if (this.customerId === this.customer.SKCC) {
            tableData.push({ label: 'V10 통계 화면', exectype: 'V10_STAT' });
          }
        }
        // tableData.push({ label: 'R-Mon', exectype: 'RMON' })
      } else {
        tableData = [
          { label: '토폴로지맵', exectype: 'TOPOLOGYMAP' },
          { label: 'Web Link', exectype: 'LINK_WWW' },
        ];
      }
      // 2019.10.08 (ryunnnne): 토폴로지맵에서 접근 시 해당 기능 숨김처리를 위해 추가(장비제어, 장비주요정보팝업 내 햄버거버튼)
      const selectedMenu = this.$store.getters.selectedMenu;
      if (selectedMenu.menuId === 'TOPOLOGYMAP') {
        tableData = remove(tableData, (data) => data.exectype !== selectedMenu.menuId);
      }
      return tableData;
    },
    customerId() {
      return this.$store.state.common.customerId;
    },
  },
  methods: {
    excuteLauncher(row) {
      if (row.exectype === 'TOPOLOGYMAP') {
        this.onTopologyMapButtonClick();
      } else if (row.exectype === 'IP_SCAN') {
        applicationLauncher().openIpScanPopup(this.objInfo.obj.objId);
      } else if (row.exectype === 'MIB_BROWSER') {
        applicationLauncher().openMibBrowserPopup(this.objInfo.obj.objId);
      } else if (row.exectype === 'V10_STAT') {
        this.onV10StatButtonClick(this.objInfo.obj.ipaddressIpv4, 'NMS.STATISTIC');
      } else {
        appApi.getAppExecuteInfo(this.objInfo.obj.objId).then((response) => {
          if (response.data.success && !isEmpty(response.data.data)) {
            const obj = response.data.data;
            if (row.exectype === 'TERMINAL') {
              row.exectype = obj.useSSH ? 'SSH' : 'TELNET';
            }
            applicationLauncher().directExecute(row.exectype, obj, this);
          }
        });
      }
    },
    onTopologyMapButtonClick() {
      if (!isEmpty(this.objInfo.obj)) {
        const objId = this.objInfo.obj.objId;
        routePathByObjId(this, objId, menuDefine.TOPOLOGYMAP);
      } else {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '장비의 정보', false));
      }
    },
    onV10StatButtonClick(ipaddress, v10MenuCode) {
      V10API.getV10ConnectionInfo(ipaddress, v10MenuCode).then((response) => {
        const result = response.data;
        if (result.success) {
          const data = result.data;
          let params = '';
          mapKeys(data, (value, key) => {
            if (params.length > 0) {
              params = `${params}&${key}=${value}`;
            } else {
              params = `${key}=${value}`;
            }
          });
          window.open(`${data.serverIp}/loginBy.do?${params}`, 'v10Static');
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/BasicSlidingButtonGroup.vue